import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import { phoneInputDataReducer } from 'Components/Forms/FormReducers/PhoneInputReducer';
import { radioInputDataReducer } from 'Components/Forms/FormReducers/RadioInputReducer';
import { selectInputDataReducer } from 'Components/Forms/FormReducers/SelectInputReducer';
import { dateInputDataReducer } from 'Components/Forms/FormReducers/DateInputReducer';
import { checkboxInputDataReducer } from 'Components/Forms/FormReducers/CheckboxInputReducer';

import { useEffect, useReducer, useState, useRef } from "react";
import { ORG_TYPES, STATUSES, TextInputObj, DEFAULT_TEXT_INPUT, FORM_ACTION_TYPES } from "Utils/constants";


var getVarValue = function (value) {
    if (typeof value === 'function') {
        return value();
    }
    else {
        return value;
    }
};


var disabledOnTest = {
    "Edit": [],
    "Create": [],
    "View": []
};

var getDisabledOn = function (disableOnFormActionOrgTypes, currentFormActionType, orgType) {
    var display = false;
    Object.keys(disableOnFormActionOrgTypes).map(type => {
        if (type.toLowerCase() == currentFormActionType.toLowerCase()) {
            display = true;
            disableOnFormActionOrgTypes[type].forEach(oT => {
                if (oT.toLowerCase() == orgType.toLowerCase()) {
                    display = true;
                }
            });
        }
    })
    return display;
};

var getReadOnlyOn = function (readOnlyOnFormActionOrgTypes, currentFormActionType, orgType) {
    var readOnly = false;
    Object.keys(readOnlyOnFormActionOrgTypes).map(type => {
        if (type.toLowerCase() == currentFormActionType.toLowerCase()) {
            readOnly = true;
            readOnlyOnFormActionOrgTypes[type].forEach(oT => {
                if (oT.toLowerCase() == orgType.toLowerCase()) {
                    readOnly = true;
                }
            });
        }
    });
    return readOnly;
};

var getNotRequiredOnlyOn = function (requiredOnlyOnFormActionOrgTypes, currentFormActionType, orgType) {
    var required = true;
    Object.keys(requiredOnlyOnFormActionOrgTypes).map(type => {
        if (type.toLowerCase() == currentFormActionType.toLowerCase()) {
            required = false;
            requiredOnlyOnFormActionOrgTypes[type].forEach(oT => {
                if (oT.toLowerCase() == orgType.toLowerCase()) {
                    required = true;
                }
            });
        }
    });
    return required;
};

export function GetTextInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var textInputObj = {
        type: 'text',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, textInputObj);
}

export function GetPhoneInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var phoneInputObj = {
        type: 'tel',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            //maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(phoneInputDataReducer, phoneInputObj);
}

export function GetRadioInputObj ({ id, name, value, radioButtons, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var radioInputObj = {
        type: 'radio',
        id: id,
        name: name,
        value: value,
        radioButtons: radioButtons,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(radioInputDataReducer, radioInputObj);
}

export function GetCheckboxInputObj ({ id, name, value, checkBoxes, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, customGetDisabledOn }) {
    var checkInputObj = {
        type: 'checkbox',
        id: id,
        name: name,
        value: value,
        checkBoxes: checkBoxes,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(checkboxInputDataReducer, checkInputObj);
}


export function GetSelectInputObj ({ id, name, value, options, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var selectInputObj = {
        type: 'select',
        id: id,
        name: name,
        value: value,
        options: options,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(selectInputDataReducer, selectInputObj);
}

export function GetDateInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var dateInputObj = {
        type: 'date',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(dateInputDataReducer, dateInputObj);
}

export function GetPasswordInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var passwordInputObj = {
        type: 'password',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, passwordInputObj);
}

/*
    password

*/
export function GetUserPasswordInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        case 'editUserPassword':
            return GetPasswordInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'To update this form, please enter your password and submit to make changes in this form.',
                description: '',
                title: '',
                placeholder: '',
                required: getNotRequiredOnlyOn({}, formActionType, orgType),//true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({}, formActionType, orgType),
                readOnly: getReadOnlyOn({}, formActionType, orgType),
                hideFieldOrgTypes: []
            });
    }

}

/**Reset password */

export function GetResetPasswordInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        case 'resetUserPassword':
            return GetPasswordInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Reset user password',
                description: '',
                title: '',
                placeholder: '',
                required: getNotRequiredOnlyOn({}, formActionType, orgType),//true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({}, formActionType, orgType),
                readOnly: getReadOnlyOn({}, formActionType, orgType),
                hideFieldOrgTypes: []
            });
    }

}

export function GetUserTextInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {

        /*
            firstname
            middlename
            lastname
            credentials
            jobTitle
            address1
            address2
            city
            zip
            zipext
            phonextn
            emailaddress
            confirmemailaddress

            prefix
            suffix
            state

            phoneForDisplay
            faxForDisplay
            
            verifiedByUser
        */
        case 'firstname':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'First Name',
                description: '',
                title: 'Enter First Name',
                placeholder: '',
                required: getNotRequiredOnlyOn({}, formActionType, orgType),//true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 75
            });
        case 'middlename':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Middle Initial',
                description: '',
                title: 'Enter Middle Initial',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 75
            });
        case 'lastname':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Last Name',
                description: '',
                title: 'Enter Last Name',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 75
            });


        case 'credentials':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Credentials',
                description: '',
                title: 'Enter Credentials',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 4000
            });
        case 'jobTitle':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Job Title',
                description: '',
                title: 'Enter Job Title',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 100
            });
        case 'address1':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Business Address Line 1',
                description: '',
                title: 'Enter Business Address',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 75
            });
        case 'address2':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Business Address Line 2',
                description: '',
                title: 'Enter Business Address. Use it to enter extra Street Address',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 75
            });
        case 'city':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'City',
                description: '',
                title: 'Enter City Name',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 75
            });

        case 'zip':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Zip Code',
                description: '',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 5
            });
        case 'zipext':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Zip Extension',
                description: '',
                title: 'Enter 4 digits for Zip Code Extension',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 4
            });

        case 'phonextn':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Phone Ext.',
                description: '(i.e 1234)',
                title: 'Enter Extension number. Example: 1234',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 5
            });

        case 'emailaddress':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Email Address',
                description: '',
                title: 'Enter email address. Example: sampleuser@gmail.com',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],


            });
        case 'confirmemailaddress':
            return GetTextInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                label: 'Confirm Email Address',
                description: '',
                title: 'Confirm Email address by entering the same email address entered in the previous field',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });

    }

}

export function GetOrgTextInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        case "name":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Organization Name',
                description: null,
                title: null,
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ "Create": [], "View": [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ "Create": [], "View": [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });
        case "psoId":
            return GetTextInputObj({
                id: "org_" + fieldName,
                name: "org_" + fieldName,
                value: fieldValue,
                label: 'Organization ID',
                description: null,
                title: null,
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ "Create": [], "View": [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ "Create": [], "View": [] }, formActionType, orgType), //CREATE: readonly if admin
                hideFieldOrgTypes: []
            });

    }

}


export function GetUserSelectInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        /*
            prefix
            suffix
            state
        */
        case 'prefix':
            return GetSelectInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Prefix',
                description: '',
                title: '',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });
        case 'suffix':
            return GetSelectInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Suffix',
                description: '',
                title: '',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });
        case 'state':
            return GetSelectInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'State',
                description: '',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });
    }
}


export function GetUserPhoneInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        /*
            
            phoneForDisplay
            faxForDisplay
            
        */
        case "phoneForDisplay":
            return GetPhoneInputObj({
                id: "user_" + fieldName,
                name: "user_" + fieldName,
                value: fieldValue,
                label: 'Phone Number',
                description: '(###) ###-####',
                title: "Enter Phone Number as 10 digits. Example: (123) 456-7890",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ "View": [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ "View": [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });

        case "faxForDisplay":
            return GetPhoneInputObj({
                id: "user_" + fieldName,
                name: "user_" + fieldName,
                value: fieldValue,
                label: 'Fax Number',
                description: '(###) ###-####',
                title: "Enter Fax Number as 10 digits. Example: (123) 456-7890",
                placeholder: "",
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ "View": [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ "View": [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });
    }
}


export function GetUserRadioInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        case "userStatus":
            return GetRadioInputObj({
                id: "user_" + fieldName,
                name: "user_" + fieldName,
                value: '',
                radioButtons: [
                    {
                        id: "active",
                        label: "Active",
                        name: "statusId",
                        value: 21,
                        title: "",
                        isChecked: false,//dets.testOrg=="Yes" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    },
                    {
                        id: "inactive",
                        label: "Inactive",
                        name: "statusId",
                        value: 22,
                        title: "",
                        isChecked: false,//dets.testOrg=="No" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    },
                    {
                        id: "terminated",
                        label: "Terminated",
                        name: "statusId",
                        value: 24,
                        title: "",
                        isChecked: false,//dets.testOrg=="No" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    }
                ],
                label: 'Account Status',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ "View": [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ "View": [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });
    }
}


export function GetUserDateInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {

    }
}

export function GetUserCheckboxInputData (fieldName, fieldValue, orgType, formActionType, customGetDisabledOn) {
    switch (fieldName) {
        /*
            verifiedByUser
        */
        case 'verifiedByUser':
            return GetCheckboxInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                value: fieldValue,
                checkBoxes: [
                    {
                        id: "contactVerify",
                        label: "I verify the above user information is correct.",
                        title: null,
                        name: "contactVerify",
                        value: false,
                        isChecked: false,
                        //onChange: handleCheckChange,
                        disabled: false
                    }
                ],
                label: 'Verify User Information',
                description: '',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });
        case 'contactType':
            return GetCheckboxInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                checkBoxes: [
                    {
                        id: "certifiedcontactid",
                        label: "AHRQ Authorized Official",
                        title: null,
                        name: "certifiedcontactid",
                        value: false,
                        isChecked: false,
                        //onChange: handleCheckChange,
                        disabled: false
                    },
                    {
                        id: "primarycontactid",
                        label: "Point of Contact",
                        title: null,
                        name: "primarycontactid",
                        value: false,
                        isChecked: false,
                        //onChange: handleCheckChange,
                        disabled: false
                    }
                ],
                label: 'Contact Types',
                description: '',
                title: '',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });

        case 'accountRolesAdditionalAccess':
            return GetCheckboxInputObj({
                id: 'user_' + fieldName,
                name: 'user_' + fieldName,
                checkBoxes: [
                    {
                        id: "collabSiteAccess",
                        label: "Help Center Access",
                        title: null,
                        name: "collabSiteAccess",
                        value: false,
                        isChecked: false,
                        //onChange: handleCheckChange,
                        disabled: customGetDisabledOn()
                    }
                ],
                label: 'Additional Access',
                description: '',
                title: '',
                placeholder: '',
                required: getNotRequiredOnlyOn({ 'Create': [], 'Edit': [] }, formActionType, orgType),//false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: []
            });


    }
}





















/*
"userInfo": {
            "emailaddress": "string",
            "token": null,
            "unencryptedpassword": "",
            "confirmemailaddress": "string",
            "userId": null,
            "creatoruserid": null,
            "creatorUserFirstName": null,
            "creatorUserMiddleName": null,
            "creatorUserLastName": null,
            "firstname": "",
            "middlename": "string",
            "lastname": "string",
            "address1": "string",
            "address2": "string",
            "city": "string",
            "zip": "string",
            "zipext": "string",
            "userStatusDescription": "",
            "userStatusReason": "",
            "orgname": "",
            "psoId": "",
            "question1": "",
            "question2": "",
            "question3": "",
            "answer1": "",
            "answer2": "",
            "answer3": "",
            "state": "string",
            "phone": "",
            "phonextn": "string",
            "fax": "",
            "contactStatusReason": "",
            "originalUserEmail": "",
            "validateedit": "",
            "jobTitle": "string",
            "credentials": "string",
            "roleCount": null,
            "prefixId": null,
            "suffixId": null,
            "prefix": "string",
            "suffix": "string",
            "contactstatusId": null,
            "organizationId": null,
            "orgTypeId": null,
            "regionId": null,
            "contactinfoId": null,
            "statusId": null,
            "createdate": null,
            "lastlogindate": null,
            "logindate": null,
            "passwordEncrypted": false,
            "isShaPasswordNull": false,
            "certifiedcontactid": false,
            "primarycontactid": false,
            "verifiedByUser": true,
            "sftpRole": false,
            "sftpRoleForLevel3": false,
            "sftpRoleForPSOAdmin": false,
            "changeWSPwdRole": false,
            "changeWSPwdRoleForLevel3": false,
            "changeWSPwdRoleForPSOAdmin": false,
            "accessToCollabSite": false,
            "roleId": null,
            "roleName": null,
            "roleDescription": null,
            "editUserPassword": null,
            "phoneForDisplay": "string",
            "faxForDisplay": "string",
            "questions": [],
            "agreedToTermsOfUse": null,
            "mfaSetupStatus": null,
            "psoadmin": false,
            "ahrquser": false,
            "psoppcmanager": false,
            "psoppcadmin": false,
            "ahrqmanager": false,
            "level1": false,
            "level3": false,
            "level2": false
        },
*/
